<div class="share-data-settings-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Share Data Settings</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content>
    <p class="dialog-description">Configure who can access this data. Changes will take effect immediately after saving.</p>
    
    <div class="share-options">
      <!-- Private Option -->
      <div class="share-option-card" [class.selected]="shareOption === 'private'" (click)="shareOption = 'private'">
        <div class="radio-container">
          <mat-radio-button color="primary" [checked]="shareOption === 'private'" (change)="shareOption = 'private'"></mat-radio-button>
          <div class="option-content">
            <div class="option-header">
              <mat-icon class="option-icon private-icon">lock</mat-icon>
              <span class="option-title">Not Share (Private)</span>
            </div>
            <p class="option-description">Data will remain private and accessible only to owner.</p>
          </div>
        </div>
      </div>
      
      <!-- Share to Specific Users -->
      <div class="share-option-card" [class.selected]="shareOption === 'specific-users'" (click)="shareOption = 'specific-users'">
        <div class="radio-container">
          <mat-radio-button color="primary" [checked]="shareOption === 'specific-users'" (change)="shareOption = 'specific-users'"></mat-radio-button>
          <div class="option-content">
            <div class="option-header">
              <mat-icon class="option-icon users-icon">people</mat-icon>
              <span class="option-title">Share to Specific Users</span>
            </div>
            <p class="option-description">Share with specific users by entering their username or email. Use semicolon (;) or Enter to add multiple users.</p>
            
            <div *ngIf="shareOption === 'specific-users'" class="input-container" (click)="$event.stopPropagation()">
              <div class="search-container">
                <input class="custom-input" placeholder="Enter username or email" 
                       [disabled]="shareOption !== 'specific-users'"
                       [value]="searchTerm"
                       (input)="onSearchInput($event)"
                       (click)="$event.stopPropagation()"
                       (blur)="hideSuggestions()"
                       (keydown.enter)="addUser($event.target.value); $event.target.value = ''; $event.preventDefault()">
                <div *ngIf="showSuggestions" class="suggestions-dropdown">
                  <div *ngFor="let user of userSuggestions" 
                       class="suggestion-item" 
                       (mousedown)="selectUser(user); $event.preventDefault()">
                    <div class="user-info">
                      <div class="user-name">{{user.userName || user.firstName + ' ' + user.lastName}}</div>
                      <div class="user-email">{{user.email}}</div>
                    </div>
                  </div>
                  <div *ngIf="userSuggestions.length === 0" class="no-results">No users found</div>
                </div>
              </div>
              <div class="input-hint">Type to search users or press Enter to add</div>
            </div>
            
            <div *ngIf="specificUsers.length > 0" class="user-chips" (click)="$event.stopPropagation()">
              <h4 class="mapped-items-header">Mapped Users:</h4>
              <div class="chips-container">
                <div *ngFor="let user of specificUsers" class="user-chip" [class.active]="shareOption === 'specific-users'" [class.loading]="user.isLoading">
                  <mat-icon class="user-icon">person</mat-icon>
                  <span *ngIf="!user.isLoading">{{user.name}}</span>
                  <span *ngIf="user.isLoading" class="loading-text">
                    <mat-spinner diameter="16" class="loading-spinner"></mat-spinner>
                    Loading user...
                  </span>
                  <mat-icon *ngIf="shareOption === 'specific-users' && !user.isLoading" class="remove-icon" (click)="removeUser(user.id); $event.stopPropagation()">cancel</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Share to Specific Roles -->
      <div class="share-option-card" [class.selected]="shareOption === 'specific-roles'" (click)="shareOption = 'specific-roles'">
        <div class="radio-container">
          <mat-radio-button color="primary" [checked]="shareOption === 'specific-roles'" (change)="shareOption = 'specific-roles'"></mat-radio-button>
          <div class="option-content">
            <div class="option-header">
              <mat-icon class="option-icon roles-icon">assignment_ind</mat-icon>
              <span class="option-title">Share to Specific Roles</span>
            </div>
            <p class="option-description">Share with all users who have specific roles in your organization. You can select multiple roles.</p>
            
            <div *ngIf="shareOption === 'specific-roles'" class="roles-container" (click)="$event.stopPropagation()">
              <div *ngIf="isLoadingRoles" class="loading-roles">
                <span>Loading roles...</span>
              </div>
              
              <div *ngIf="!isLoadingRoles && availableRoles.length === 0" class="no-roles">
                <span>No roles available</span>
              </div>
              
              <div *ngIf="!isLoadingRoles && availableRoles.length > 0" class="roles-list">
                <div *ngFor="let role of availableRoles" 
                     class="role-item" 
                     [class.selected]="isRoleSelected(role.id)"
                     (click)="toggleRole(role); $event.stopPropagation()">
                  <div class="role-checkbox">
                    <mat-icon *ngIf="isRoleSelected(role.id)">check_box</mat-icon>
                    <mat-icon *ngIf="!isRoleSelected(role.id)">check_box_outline_blank</mat-icon>
                  </div>
                  <div class="role-name">{{role.displayName}}</div>
                </div>
              </div>
            </div>
            
            <div *ngIf="specificRoles.length > 0" class="role-chips" (click)="$event.stopPropagation()">
              <h4 class="mapped-items-header">Mapped Roles:</h4>
              <div class="chips-container">
                <div *ngFor="let role of specificRoles" class="role-chip" [class.active]="shareOption === 'specific-roles'">
                  <mat-icon class="role-icon">assignment_ind</mat-icon>
                  {{role.name}}
                  <mat-icon *ngIf="shareOption === 'specific-roles'" class="remove-icon" (click)="removeRole(role.id); $event.stopPropagation()">cancel</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Public Data -->
      <div class="share-option-card" [class.selected]="shareOption === 'public'" (click)="shareOption = 'public'">
        <div class="radio-container">
          <mat-radio-button color="primary" [checked]="shareOption === 'public'" (change)="shareOption = 'public'"></mat-radio-button>
          <div class="option-content">
            <div class="option-header">
              <mat-icon class="option-icon public-icon">public</mat-icon>
              <span class="option-title">Public Data</span>
            </div>
            <p class="option-description">Data will be accessible to everyone.</p>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button [disabled]="isSaving" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="isSaving" (click)="onSaveChanges()">
      <span *ngIf="!isSaving">Save Changes</span>
      <span *ngIf="isSaving">Saving... <mat-spinner diameter="16" style="display: inline-block; margin-left: 8px;"></mat-spinner></span>
    </button>
  </mat-dialog-actions>
</div>
